document.querySelectorAll('.radio-button-group__check-all').forEach((checkAll) => {
  const parent = checkAll.closest('.radio-button-group');
  const checkYes = parent.querySelector('.check-yes');
  const checkNo = parent.querySelector('.check-no');
  const radios = parent.querySelectorAll('.radio-button-group__content input[type="radio"]');

  const updateActiveClass = () => {
    const allYesChecked = [...radios].every((radio) => radio.value === 'Yes' && radio.checked);
    const allNoChecked = [...radios].every((radio) => radio.value === 'No' && radio.checked);

    checkYes.classList.toggle('is-active', allYesChecked);
    checkNo.classList.toggle('is-active', allNoChecked);
  };

  checkYes.addEventListener('click', () => {
    radios.forEach((radio) => (radio.checked = radio.value === 'Yes'));
    checkYes.classList.add('is-active');
    checkNo.classList.remove('is-active');
  });

  checkNo.addEventListener('click', () => {
    radios.forEach((radio) => (radio.checked = radio.value === 'No'));
    checkNo.classList.add('is-active');
    checkYes.classList.remove('is-active');
  });

  radios.forEach((radio) => radio.addEventListener('change', updateActiveClass));
});
